import React from "react";
import { Badge } from "@/components/ui/badge";

const STATUS_MAP = {
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  in_progress: "bg-blue-50 text-blue-700 border-blue-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  done: "bg-emerald-50 text-emerald-700 border-emerald-200",
  issue_found: "bg-red-50 text-red-700 border-red-200",
  overdue: "bg-red-50 text-red-700 border-red-200",
  open: "bg-amber-50 text-amber-700 border-amber-200",
  assigned: "bg-blue-50 text-blue-700 border-blue-200",
  resolved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  closed: "bg-zinc-100 text-zinc-700 border-zinc-200",
  reopened: "bg-red-50 text-red-700 border-red-200",
};

const PRIORITY_MAP = {
  low: "bg-zinc-50 text-zinc-700 border-zinc-200",
  medium: "bg-blue-50 text-blue-700 border-blue-200",
  high: "bg-amber-50 text-amber-700 border-amber-200",
  critical: "bg-red-50 text-red-700 border-red-200",
};

export function StatusBadge({ status }) {
  const cls = STATUS_MAP[status] || "bg-zinc-50 text-zinc-700 border-zinc-200";
  return (
    <Badge data-testid={`status-badge-${status}`} variant="outline" className={`${cls} uppercase tracking-wide text-[10px] font-semibold`}>
      {status?.replace(/_/g, " ")}
    </Badge>
  );
}

export function PriorityBadge({ priority }) {
  const cls = PRIORITY_MAP[priority] || PRIORITY_MAP.low;
  return (
    <Badge data-testid={`priority-badge-${priority}`} variant="outline" className={`${cls} uppercase tracking-wide text-[10px] font-semibold`}>
      {priority}
    </Badge>
  );
}

export function statusBarClass(status) {
  if (status === "completed" || status === "done" || status === "resolved") return "status-bar-done";
  if (status === "overdue" || status === "issue_found" || status === "reopened") return "status-bar-overdue";
  if (status === "in_progress" || status === "assigned") return "status-bar-progress";
  return "status-bar-pending";
}
